import request from '../../utils/request'

export default {
    getTemplates() {
        return request({
            url: "/template/getTemplates",
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: 'get',
        })
    },
    getTemplateById(data) {
        return request({
            url: "/template/getTemplateById",
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: 'get',
            params: data,
        })
    },
    addTemplate(data) {
        return request({
            url: "/template/addTemplate",
            method: 'Post',
            data,
            // headers: { token: sessionStorage.getItem("token") },
        })
    },
    addTemplateWithUploadFile(data) {
        return request({
            url: "/template/addTemplateWithUploadFile",
            method: 'Post',
            data,
            headers: { token: sessionStorage.getItem("token") },
        })
    },
    removeTemplate(data) {
        return request({
            url: "/template/removeTemplate",
            method: 'get',
            headers: { token: sessionStorage.getItem("token") },
            params: data
        })
    },
    editTemplate(data) {
        return request({
            url: "/template/editTemplate",
            method: 'Post',
            data,
        })
    },
    getPlansByTemplate(data) {
        return request({
            url: "/template/getPlansByTemplate",
            method: 'get',
            params: data,
        })
    },
    getPlanById(data) {
        return request({
            url: "/template/getPlanById",
            method: 'get',
            params: data,
        })
    },
    addPlan(data) {
        return request({
            url: "/template/addPlan",
            method: 'Post',
            data,
        })
    },
    addPlanWithUploadFile(data) {
        return request({
            url: "/template/addPlanWithUploadFile",
            method: 'Post',
            data,
        })
    },
    removePlan(data) {
        return request({
            url: "/template/removePlan",
            method: 'get',
            params: data,
        })
    },
    editPlan(data) {
        return request({
            url: "/template/editPlan",
            method: 'Post',
            data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/report.js